import {
  generateGenericPDFPages,
  generatePDF,
} from '../../../helper/pdfGenerator';
import { PDFResult } from '../../../models/pdfModal';
import { FormModel } from '../../../models/questionModel';

export const generateFormSummaryReport = async (
  forms: FormModel[]
): Promise<PDFResult> => {
  const allForms = forms
    .map((f) => generateGenericPDFPages(f, 'summary'))
    .flat();

  return await generatePDF('Form Summary', allForms);
};
